import { HubFeature } from '@ats/api/cm';
import { LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Scheduling|Schedule an Exam|Certiverse';

export type SSOEgressCertiverse =
	| 'CPSSOEgressCertiverseButton'
	| 'CPSSOEgressCertiverseTabTitle'
	| 'CPSSOEgressCertiversePageTitle'
	| 'CPSSOEgressCertiversePageDescription';

export const ssoEgressCertiverseLocs: LocDefs<SSOEgressCertiverse> = {
	CPSSOEgressCertiverseButton: {
		defaultValue: 'SSO to Certiverse',
		description: 'Button to SSO to Certiverse.',
		displayPath: `${dpRoot}|SSO Button`,
		displayType: 'Button',
		feature: HubFeature.CandidateAccessIntegrationEgressOidcEgressCertiverse,
		portal: 'CP',
		htmlAllowed: false,
	},
	CPSSOEgressCertiverseTabTitle: {
		defaultValue: 'Schedule an Exam',
		description: 'Tab title of certiverse SSO page.',
		displayPath: `${dpRoot}|Tab Title`,
		displayType: 'Title',
		feature: HubFeature.CandidateAccessIntegrationEgressOidcEgressCertiverse,
		portal: 'CP',
		htmlAllowed: false,
	},
	CPSSOEgressCertiversePageTitle: {
		defaultValue: 'Certiverse SSO',
		description: 'Title of certiverse SSO page.',
		displayPath: `${dpRoot}|Title`,
		displayType: 'Title',
		feature: HubFeature.CandidateAccessIntegrationEgressOidcEgressCertiverse,
		portal: 'CP',
		htmlAllowed: false,
	},
	CPSSOEgressCertiversePageDescription: {
		defaultValue: '',
		description: 'Title of certiverse SSO page.',
		displayPath: `${dpRoot}|Page Description`,
		displayType: 'Content',
		feature: HubFeature.CandidateAccessIntegrationEgressOidcEgressCertiverse,
		portal: 'CP',
		htmlAllowed: true,
	},
};

export const LOC_KEYS = MapLocKeys<SSOEgressCertiverse>(ssoEgressCertiverseLocs);
